"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromCAIP19 = exports.toCAIP19 = exports.fromAssetId = exports.toAssetId = exports.ASSET_REFERENCE = void 0;
// https://github.com/ChainAgnostic/CAIPs/blob/master/CAIPs/caip-19.md
const types_1 = require("@shapeshiftoss/types");
const chainId_1 = require("../chainId/chainId");
const assetNamespaceStrings = [
    'cw20',
    'cw721',
    'erc20',
    'erc721',
    'slip44',
    'native',
    'ibc'
];
exports.ASSET_REFERENCE = {
    Bitcoin: '0',
    Ethereum: '60',
    Cosmos: '118',
    Osmosis: '118'
};
const validAssetNamespaces = Object.freeze({
    [types_1.ChainTypes.Bitcoin]: ['slip44'],
    [types_1.ChainTypes.Ethereum]: ['slip44', 'erc20', 'erc721'],
    [types_1.ChainTypes.Cosmos]: ['cw20', 'cw721', 'ibc', 'native', 'slip44'],
    [types_1.ChainTypes.Osmosis]: ['cw20', 'cw721', 'ibc', 'native', 'slip44']
});
const isAssetNamespace = (maybeAssetNamespace) => assetNamespaceStrings.some((s) => s === maybeAssetNamespace);
/**
 * validate that a value is a string slip44 value
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0044.md
 * @param {string} value - possible slip44 value
 */
const isValidSlip44 = (value) => {
    const n = Number(value);
    // slip44 has a max value of an unsigned 32-bit integer
    return !isNaN(n) && n >= 0 && n < 4294967296;
};
const toAssetId = (args) => {
    const { chain, network, assetNamespace } = args;
    let { assetReference } = args;
    if (!chain)
        throw new Error('toAssetId: No chain provided');
    if (!network)
        throw new Error('toAssetId: No chainReference Provided');
    if (!assetNamespace)
        throw new Error('toAssetId: No assetNamespace provided');
    if (!assetReference)
        throw new Error('toAssetId: No assetReference provided');
    const chainId = (0, chainId_1.toChainId)({ chain, network });
    if (!validAssetNamespaces[chain].includes(assetNamespace)) {
        throw new Error(`toAssetId: Asset Namespace ${assetNamespace} not supported for chain ${chain}`);
    }
    if (assetNamespace === 'slip44' && !isValidSlip44(String(assetReference))) {
        throw new Error(`Invalid reference for namespace slip44`);
    }
    if (Array('erc20', 'erc721').includes(assetNamespace)) {
        if (!assetReference.startsWith('0x')) {
            throw new Error(`toAssetId: assetReference must start with 0x: ${assetReference}`);
        }
        if (assetReference.length !== 42) {
            throw new Error(`toAssetId: assetReference length must be 42, length: ${assetReference.length}`);
        }
        // We make Eth contract addresses lower case to simplify comparisons
        assetReference = assetReference.toLowerCase();
    }
    return `${chainId}/${assetNamespace}:${assetReference}`;
};
exports.toAssetId = toAssetId;
const parseAssetIdRegExp = /([-a-z\d]{3,8}):([-a-zA-Z\d]{1,32})\/([-a-z\d]{3,8}):([-a-zA-Z\d]+)/;
const fromAssetId = (assetId) => {
    var _a;
    const matches = (_a = parseAssetIdRegExp.exec(assetId)) !== null && _a !== void 0 ? _a : [];
    // We're okay casting these strings to enums because we check to make sure
    // they are valid enum values
    let chain = chainId_1.chainNamespaceToChainType[matches[1]];
    const network = chainId_1.chainReferenceToNetworkType[matches[2]];
    const assetNamespace = isAssetNamespace(matches[3]) ? matches[3] : undefined;
    let assetReference = matches[4];
    if (chain && network && assetNamespace && assetReference) {
        switch (network) {
            case types_1.NetworkTypes.OSMOSIS_MAINNET:
            case types_1.NetworkTypes.OSMOSIS_TESTNET:
                chain = types_1.ChainTypes.Osmosis;
        }
        switch (assetNamespace) {
            case 'erc20':
            case 'erc721': {
                assetReference = assetReference.toLowerCase();
            }
        }
        return { chain, network, assetNamespace, assetReference };
    }
    throw new Error(`fromAssetId: invalid AssetId: ${assetId}`);
};
exports.fromAssetId = fromAssetId;
exports.toCAIP19 = exports.toAssetId;
exports.fromCAIP19 = exports.fromAssetId;
